import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import PaginationOwn from "../_common/ownPagination";
import InputComponent from "../_common/inputComponent";

const ReportUserDataTable = (props) => {
  const { t } = useTranslation();
  const [searchVal, setSearchVal] = useState("");
  const headers = [
    { label: t("admin.reports.userData.registrationDate"), key: "userRegisterDate" },
    { label: t("admin.reports.userData.transactionDate"), key: "transactionTime" },
    { label: t("common.type"), key: "type" },
    { label: t("admin.reports.userData.gender"), key: "userGender" },
    { label: t("admin.reports.userData.dob"), key: "userDob" },
    { label: t("admin.reports.userData.postcode"), key: "userPostalCode" },
    { label: t("admin.reports.userData.phone"), key: "userMobile" },
    { label: t("admin.reports.userZone"), key: "userZone" },
    { label: t("admin.reports.userData.venueName"), key: "storeName" },
    { label: t("admin.reports.userData.venueStreet"), key: "storeStreet" },
    { label: t("admin.reports.userData.venueAddress"), key: "storeAddress" },
    { label: t("admin.reports.userData.venueCity"), key: "storeCity" },
    { label: t("admin.reports.userData.venuePostcode"), key: "storePostalCode" },
    { label: t("admin.reports.venueZone"), key: "venueZone" },
    { label: t("admin.reports.userData.productName"), key: "productName" },
  ];
  return (
    <>
      <div className="pt-4 admin-controls ps-4">
        <form
          onSubmit={(ev) =>
            // eslint-disable-next-line
            props?.searchFunc(ev, props?.searchVal)}
          className="col-12 col-lg-6 admin-search"
        >
          <div className="search-wrapper">
            <InputComponent
              placeholder={t("admin.reports.searchUser")}
              label={t("admin.reports.searchUser")}
              type="text"
              name="search"
              theme="admin"
              value={props?.searchVal}
              handleCallback={(val) => {
                // eslint-disable-next-line
                props?.setSearchVal?.(val);
              }}
            />
          </div>
          <button type="submit" className="btn secondary-btn">
            {t("common.go")}
          </button>
        </form>
      </div>
      <div className="report-wrapper user-data-wrapper">
        {props?.reportData?.length > 0 ? (
          <div className="report-table-wrapper">
            <div className="download-btn pb-3 pb-md-4 pt-3">
              <CSVLink
                className="btn admin-btn secondary-btn"
                data={props?.allReport}
                filename={"user-data-report.csv"}
                headers={headers}
              >
                {t("common.downloadCsv")}
              </CSVLink>
              {props?.reportData?.length > 0 && (
                <div className="px-0 col-12 pt-3">
                  <PaginationOwn
                    pageSize={props?.pageSize}
                    changePageSize={props?.changePageSize}
                    goToPage={props?.goToPage}
                    totalCount={props?.totalCount}
                    currentPage={props?.currentPage}
                    applicationType={props?.applicationType}
                    paginationType="report"
                  />
                </div>
              )}
            </div>

            <p className="report-type">{t("admin.reports.userData.condomUsage")}</p>
            <div>
              <div className="table-responsive table-own">
                <table className="table table-striped table-hover table-admin">
                  <thead className="user-data-report">
                    <tr>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userRegisterDate"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() =>
                          // eslint-disable-next-line
                          props?.arraySorting("userRegisterDate")}
                      >
                        <span>{t("admin.reports.userData.registrationDate")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "type"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() =>
                          // eslint-disable-next-line
                          props?.arraySorting("type")}
                      >
                        <span>{t("common.type")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "transactionTime"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("transactionTime")}
                      >
                        <span>{t("admin.reports.userData.transactionDate")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userGender"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("userGender")}
                      >
                        <span>{t("admin.reports.userData.gender")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userDob" ? "active" : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("userDob")}
                      >
                        <span>{t("admin.reports.userData.dob")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userPostalCode"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("userPostalCode")}
                      >
                        <span>{t("admin.reports.userData.postcode")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userMobile"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("userMobile")}
                      >
                        <span>{t("admin.reports.userData.phone")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "userZone"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("userZone")}
                      >
                        <span>{t("admin.reports.userZone")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "storeName" ? "active" : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storeName")}
                      >
                        <span>{t("admin.reports.userData.venueName")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "storeStreet"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storeStreet")}
                      >
                        <span>{t("admin.reports.userData.venueStreet")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "storeAddress"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storeAddress")}
                      >
                        <span>{t("admin.reports.userData.venueAddress")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "storeCity" ? "active" : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storeCity")}
                      >
                        <span>{t("admin.reports.userData.venueCity")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "storePostalCode"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("storePostalCode")}
                      >
                        <span>{t("admin.reports.userData.venuePostcode")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "venueZone"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("venueZone")}
                      >
                        <span>{t("admin.reports.venueZone")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                      <th
                        className={`sort-header cursor ${props?.sortObj.sortVal === "productName"
                          ? "active"
                          : ""
                          } ${props?.sortObj.sortType ? "aesc" : "desc"}`}
                        onClick={() => props?.arraySorting("productName")}
                      >
                        <span>{t("admin.reports.userData.productName")}</span>
                        {props?.sortObj?.sortType === "aesc" && (
                          <i className="fas fa-caret-down"></i>
                        )}
                        {props?.sortObj?.sortType === "desc" && (
                          <i className="fas fa-caret-up"></i>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {props?.reportData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {data.userRegisterDate
                              ? data?.userRegisterDate
                              : t("common.na")}
                          </td>
                          <td>{data?.type || t("common.na")}</td>
                          <td>
                            {data?.transactionTime
                              ? data?.transactionTime
                              : t("common.na")}
                          </td>
                          <td>{data?.userGender}</td>
                          <td>{data?.userDob ? data?.userDob : t("common.na")}</td>
                          <td>{data?.userPostalCode}</td>
                          <td>{data?.userMobile}</td>
                          <td>{data?.userZone}</td>
                          <td>{data?.storeName}</td>
                          <td>{data?.storeStreet}</td>
                          <td>{data?.storeAddress}</td>
                          <td>{data?.storeCity}</td>
                          <td>{data?.storePostalCode}</td>
                          <td>{data?.venueZone}</td>
                          <td>{data?.productName}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="pr-3 w-100 pt-3">
            <div className="no-data-available w-100">{t("admin.reports.userData.noDataFound")}</div>
          </div>
        )}
      </div>
    </>
  );
};

export default ReportUserDataTable;
